(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["codex-infinite-products"] && !Shopify.designMode) return;
  try {
    
  const initializeInfiniteProducts = (scope = document) => {
    scope.querySelectorAll('[data-codex-infinite-products]').forEach((root) => {
      if (root.dataset.infiniteBound === 'true') return;
      root.dataset.infiniteBound = 'true';

      const grid = root.querySelector('[data-infinite-grid]');
      const sentinel = root.querySelector('[data-infinite-sentinel]');
      const loadMore = root.querySelector('[data-infinite-load-more]');
      const actionLabel = root.querySelector('[data-infinite-action-label]');
      const spinner = root.querySelector('[data-infinite-spinner]');
      const liveRegion = root.querySelector('[data-infinite-live]');
      if (!grid || !sentinel || !loadMore || !root.dataset.nextUrl) return;

      const pageSize = Number(root.dataset.pageSize) || 12;
      const totalPages = Number(root.dataset.totalPages) || 1;
      const currentPage = Number(root.dataset.currentPage) || 1;
      const restartAtFirstPage = root.dataset.restartAtFirstPage === 'true' && currentPage > 1;
      const labels = {
        loadMore: root.dataset.labelLoadMore,
        loading: root.dataset.labelLoading,
        retry: root.dataset.labelRetry,
        complete: root.dataset.labelComplete,
        loaded: root.dataset.labelLoaded
      };
      const productHandleFromUrl = (value) => {
        if (!value) return '';
        try {
          const url = new URL(value, window.location.origin);
          const marker = '/products/';
          const markerIndex = url.pathname.indexOf(marker);
          if (markerIndex === -1) return '';
          return decodeURIComponent(url.pathname.slice(markerIndex + marker.length).split('/')[0]).toLowerCase();
        } catch (error) {
          return '';
        }
      };
      const productKey = (item) => {
        const handle = item.dataset.productHandle || productHandleFromUrl(item.querySelector('a[href*="/products/"]')?.href);
        return handle.toLowerCase();
      };
      const seenProducts = new Set();
      const currentProductHandle = root.dataset.currentProductHandle?.toLowerCase();
      if (currentProductHandle) seenProducts.add(currentProductHandle);

      const collectPageProducts = () => {
        const pageMain = document.getElementById('MainContent') || document.querySelector('main') || document;
        pageMain.querySelectorAll('a[href*="/products/"]').forEach((link) => {
          if (root.contains(link)) return;
          const handle = productHandleFromUrl(link.href);
          if (handle) seenProducts.add(handle);
        });
      };

      collectPageProducts();
      const initialItems = Array.from(grid.querySelectorAll('[data-infinite-item]'));
      if (restartAtFirstPage) {
        initialItems.forEach((item) => item.remove());
      } else {
        initialItems.forEach((item) => {
          const key = productKey(item);
          if (key && seenProducts.has(key)) {
            item.remove();
            return;
          }
          if (key) seenProducts.add(key);
        });
      }
      const queuedPageCount = restartAtFirstPage ? totalPages : Math.max(totalPages - currentPage, 0);
      const pageQueue = Array.from({ length: queuedPageCount }, (_, index) => {
        if (restartAtFirstPage) return index + 1;
        return currentPage + index + 1;
      });
      let loading = false;
      let finished = false;
      let observer;

      const announce = (message) => {
        if (!liveRegion) return;
        liveRegion.textContent = '';
        window.setTimeout(() => { liveRegion.textContent = message; }, 20);
      };

      const setState = (state) => {
        sentinel.dataset.state = state;
        grid.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
        if (actionLabel) {
          actionLabel.textContent = state === 'retry' ? labels.retry : labels.loadMore;
        }
        if (spinner) spinner.textContent = labels.loading;
      };

      const acceptUniqueItems = (items) => items.filter((item) => {
        const key = productKey(item);
        if (!key || seenProducts.has(key)) return false;
        seenProducts.add(key);
        return true;
      });

      const fetchPage = async (page) => {
        const url = new URL(window.location.href);
        url.searchParams.set('page', String(page));
        url.searchParams.set('section_id', root.dataset.sectionId);
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 12000);

        try {
          const response = await fetch(url.toString(), {
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            signal: controller.signal
          });
          if (!response.ok) throw new Error(`Request failed with ${response.status}`);
          const html = await response.text();
          const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
          const nextRoot = parsedDocument.querySelector('[data-codex-infinite-products]');
          if (!nextRoot) throw new Error('Product section was missing');
          return Array.from(nextRoot.querySelectorAll('[data-infinite-item]'));
        } finally {
          window.clearTimeout(timeout);
        }
      };

      const fetchNextPage = async () => {
        const page = pageQueue.shift();
        if (!page) return [];

        try {
          return acceptUniqueItems(await fetchPage(page));
        } catch (error) {
          pageQueue.unshift(page);
          throw error;
        }
      };

      const finish = () => {
        finished = true;
        if (observer) observer.disconnect();
        setState('complete');
        announce(labels.complete);
        loadMore.remove();
        if (spinner) spinner.remove();
        const completeLabel = document.createElement('span');
        completeLabel.textContent = labels.complete;
        sentinel.insertBefore(completeLabel, liveRegion || null);
      };

      const isSentinelNearViewport = () => {
        const bounds = sentinel.getBoundingClientRect();
        return bounds.top <= window.innerHeight + 600 && bounds.bottom >= -600;
      };

      const appendNextItems = async () => {
        if (loading || finished) return;
        loading = true;
        setState('loading');

        try {
          collectPageProducts();
          const nextItems = await fetchNextPage();
          nextItems.forEach((item) => grid.appendChild(item));
          if (nextItems.length) announce(labels.loaded.replace('__COUNT__', String(nextItems.length)));

          if (!pageQueue.length) {
            finish();
          } else {
            setState('idle');
          }
        } catch (error) {
          setState('retry');
        } finally {
          loading = false;
          if (!finished && sentinel.dataset.state === 'idle') {
            window.setTimeout(() => {
              if (isSentinelNearViewport()) appendNextItems();
            }, 100);
          }
        }
      };

      loadMore.addEventListener('click', (event) => {
        event.preventDefault();
        appendNextItems();
      });

      const startInfiniteFeed = () => {
        if (!pageQueue.length) {
          finish();
          return;
        }

        setState('idle');
        observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting) && sentinel.dataset.state !== 'retry') {
            appendNextItems();
          }
        }, { rootMargin: '600px 0px', threshold: 0.01 });
        observer.observe(sentinel);
        if (isSentinelNearViewport()) appendNextItems();
      };

      startInfiniteFeed();
    });
  };

  initializeInfiniteProducts();
  document.addEventListener('shopify:section:load', (event) => initializeInfiniteProducts(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (() => {
    const bindCompactMenu = () => {
      if (!document.body.classList.contains('nks-compact-header')) return;
      document.querySelectorAll('.nks-home-store-header [data-nks-header-menu-trigger]').forEach((trigger) => {
        if (trigger.dataset.nksHeaderMenuBound === 'true') return;
        const drawer = trigger.closest('.header')?.querySelector('header-drawer');
        const details = drawer?.querySelector(':scope > details');
        const summary = details?.querySelector(':scope > summary');
        if (!details || !summary) return;
        trigger.dataset.nksHeaderMenuBound = 'true';
        trigger.setAttribute('aria-expanded', String(details.open));
        let openedFromHeader = false;
        trigger.addEventListener('click', () => {
          window.NKSSuperSearch?.closeAll?.();
          openedFromHeader = !details.open;
          summary.click();
          window.requestAnimationFrame(() => {
            if (details.open) summary.focus({ preventScroll: true });
          });
        });
        details.addEventListener('toggle', () => {
          trigger.setAttribute('aria-expanded', String(details.open));
          if (details.open) window.NKSSuperSearch?.closeAll?.();
          if (!details.open && openedFromHeader) {
            openedFromHeader = false;
            trigger.focus({ preventScroll: true });
          }
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindCompactMenu, { once: true });
    else bindCompactMenu();
    document.addEventListener('shopify:section:load', bindCompactMenu);
  })();

  (() => {
    if (document.body.classList.contains('nks-compact-header')) return;
    const slot = document.querySelector('.header__menu-sticky-slot');
    const row = slot?.querySelector('.header__menu-row');
    const headerSection = document.querySelector('.section-header');
    if (!slot || !row) return;

    const desktopMedia = window.matchMedia('(min-width: 990px)');
    const cartSlot = row.querySelector('.header__menu-cart-slot');
    const cartButton = headerSection?.querySelector('#cart-icon-bubble');
    const cartHome = cartButton?.parentElement;
    const cartNextSibling = cartButton?.nextElementSibling;

    const positionCart = (fixed) => {
      if (!cartSlot || !cartButton || !cartHome) return;
      if (fixed && cartButton.parentElement !== cartSlot) {
        cartSlot.appendChild(cartButton);
      } else if (!fixed && cartButton.parentElement !== cartHome) {
        const nextSibling = cartNextSibling?.parentElement === cartHome ? cartNextSibling : null;
        cartHome.insertBefore(cartButton, nextSibling);
      }
    };

    let anchorTop = 0;

    const measure = () => {
      slot.classList.remove('is-menu-fixed');
      positionCart(false);
      const rowHeight = row.offsetHeight;
      slot.style.setProperty('--header-menu-row-height', `${rowHeight}px`);
      anchorTop = slot.getBoundingClientRect().top + window.scrollY;
      update();
    };

    const update = () => {
      const headerIsHidden = headerSection?.classList.contains('shopify-section-header-hidden');
      const fixed = desktopMedia.matches && window.scrollY >= anchorTop && Boolean(headerIsHidden);
      slot.classList.toggle('is-menu-fixed', fixed);
      positionCart(fixed);
    };

    const headerStateObserver = new MutationObserver(update);
    if (headerSection) {
      headerStateObserver.observe(headerSection, {
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    measure();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  (() => {
    const init = () => {
      document.querySelectorAll('cart-items').forEach((cartItems) => {
        if (cartItems.dataset.nksFloatingReady === 'true') return;
        cartItems.dataset.nksFloatingReady = 'true';

        cartItems.addEventListener('click', (event) => {
          const backToTop = event.target.closest('.nks-cart-back-to-top');
          if (!backToTop || !cartItems.contains(backToTop)) return;

          window.scrollTo({
            top: 0,
            left: 0,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
          });
        });

        let topObserver;
        let footerObserver;
        const setupFloatingCheckout = () => {
          const topCheckout = cartItems.querySelector('.nks-cart-top-checkout');
          const floatingCheckout = cartItems.querySelector('.nks-cart-floating-checkout');
          const footerCheckout = document.getElementById('checkout');

          if (!topCheckout || !floatingCheckout || floatingCheckout.dataset.ready === 'true') return;

          topObserver?.disconnect();
          footerObserver?.disconnect();
          floatingCheckout.dataset.ready = 'true';
          let topCheckoutVisible = true;
          let footerCheckoutVisible = false;

          const updateFloatingCheckout = () => {
            floatingCheckout.hidden = topCheckoutVisible || footerCheckoutVisible;
          };

          topObserver = new IntersectionObserver(([entry]) => {
            topCheckoutVisible = entry.isIntersecting;
            updateFloatingCheckout();
          });

          topObserver.observe(topCheckout);

          if (footerCheckout) {
            footerObserver = new IntersectionObserver(([entry]) => {
              footerCheckoutVisible = entry.isIntersecting;
              updateFloatingCheckout();
            });

            footerObserver.observe(footerCheckout);
          }
        };

        setupFloatingCheckout();
        new MutationObserver(setupFloatingCheckout).observe(cartItems, { childList: true });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nks-collection-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nks-collection-hero-slider')) {
    class NksCollectionHeroSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        this.mobileNextButtons = Array.from(this.querySelectorAll('[data-mobile-next]'));
        this.autoplayButton = this.querySelector('[data-autoplay-toggle]');
        this.status = this.querySelector('[data-status]');
        this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.interval = Number(this.dataset.interval) || 6000;
        this.mobileAutoplayEnabled = this.dataset.mobileAutoplay === 'true';
        this.mobileInterval = Number(this.dataset.mobileInterval) || 3000;
        this.mobileViewport = window.matchMedia('(max-width: 749px)');
        this.pausedByUser = false;
        this.isHovered = false;
        this.hasFocus = false;
        this.pointerStartX = null;
        this.resizeFrame = null;
        this.imageWarmupTimer = null;
        this.showRequestId = 0;
        this.onResize = () => {
          window.cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = window.requestAnimationFrame(() => this.normalizeHeadingWidths());
        };

        window.addEventListener('resize', this.onResize);
        window.requestAnimationFrame(() => this.normalizeHeadingWidths());
        document.fonts?.ready.then(() => this.normalizeHeadingWidths());

        if (this.slides.length < 2) return;

        this.onPrevious = () => this.show(this.currentIndex - 1, true);
        this.onNext = () => this.show(this.currentIndex + 1, true);
        this.onMobileNext = async (event) => {
          const restoreFocus = event.detail === 0;
          await this.show(this.currentIndex + 1, true);
          if (!restoreFocus) return;
          window.requestAnimationFrame(() => {
            this.slides[this.currentIndex]?.querySelector('[data-mobile-next]')?.focus({ preventScroll: true });
          });
        };
        this.onPointerDown = (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          this.pointerStartX = event.clientX;
        };
        this.onPointerUp = (event) => {
          if (this.pointerStartX === null) return;
          const distance = event.clientX - this.pointerStartX;
          this.pointerStartX = null;
          if (Math.abs(distance) < 48) return;
          this.show(distance < 0 ? this.currentIndex + 1 : this.currentIndex - 1, true);
        };
        this.onMouseEnter = () => {
          this.isHovered = true;
          if (!this.mobileViewport.matches) this.stopAutoplay();
        };
        this.onMouseLeave = () => {
          this.isHovered = false;
          this.startAutoplay();
        };
        this.onFocusIn = () => {
          this.hasFocus = true;
          this.stopAutoplay();
        };
        this.onFocusOut = (event) => {
          if (!this.contains(event.relatedTarget)) {
            this.hasFocus = false;
            this.startAutoplay();
          }
        };
        this.onVisibilityChange = () => {
          if (document.hidden) this.stopAutoplay();
          else this.startAutoplay();
        };
        this.onAutoplayBreakpointChange = () => this.restartAutoplay();

        this.previousButton?.addEventListener('click', this.onPrevious);
        this.nextButton?.addEventListener('click', this.onNext);
        this.mobileNextButtons.forEach((button) => button.addEventListener('click', this.onMobileNext));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.dot), true)));
        this.autoplayButton?.addEventListener('click', () => this.toggleAutoplay());
        this.addEventListener('pointerdown', this.onPointerDown);
        this.addEventListener('pointerup', this.onPointerUp);
        this.addEventListener('pointercancel', () => { this.pointerStartX = null; });
        this.addEventListener('mouseenter', this.onMouseEnter);
        this.addEventListener('mouseleave', this.onMouseLeave);
        this.addEventListener('focusin', this.onFocusIn);
        this.addEventListener('focusout', this.onFocusOut);
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.mobileViewport.addEventListener('change', this.onAutoplayBreakpointChange);

        this.show(this.currentIndex, false);
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        this.previousButton?.removeEventListener('click', this.onPrevious);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.mobileNextButtons?.forEach((button) => button.removeEventListener('click', this.onMobileNext));
        this.removeEventListener('pointerdown', this.onPointerDown);
        this.removeEventListener('pointerup', this.onPointerUp);
        this.removeEventListener('mouseenter', this.onMouseEnter);
        this.removeEventListener('mouseleave', this.onMouseLeave);
        this.removeEventListener('focusin', this.onFocusIn);
        this.removeEventListener('focusout', this.onFocusOut);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        this.mobileViewport?.removeEventListener('change', this.onAutoplayBreakpointChange);
        window.removeEventListener('resize', this.onResize);
        window.cancelAnimationFrame(this.resizeFrame);
        window.clearTimeout(this.imageWarmupTimer);
      }

      normalizeHeadingWidths() {
        const isDesktop = window.matchMedia('(min-width: 750px)').matches;

        this.querySelectorAll('[data-heading-ink]').forEach((ink) => {
          ink.style.removeProperty('--nks-heading-scale');
          if (!isDesktop) return;

          const line = ink.closest('.nks-collection-hero__heading-line');
          const naturalWidth = ink.offsetWidth;
          const targetWidth = Math.min(450, (line?.clientWidth || 0) * 0.76);
          if (!naturalWidth || !targetWidth) return;

          const scale = Math.min(1.8, Math.max(0.58, targetWidth / naturalWidth));
          ink.style.setProperty('--nks-heading-scale', scale.toFixed(4));
        });
      }

      loadSlideImages(slide, priority = 'auto') {
        slide.querySelectorAll('.nks-collection-hero__sign-image, .nks-collection-hero__image').forEach((image) => {
          if (priority === 'high') {
            image.loading = 'eager';
            image.fetchPriority = 'high';
          } else if (priority === 'low') {
            image.loading = 'eager';
            image.fetchPriority = 'low';
          }
        });

        slide.querySelectorAll('source[data-deferred-srcset]').forEach((source) => {
          source.srcset = source.dataset.deferredSrcset;
          source.removeAttribute('data-deferred-srcset');
        });

        slide.querySelectorAll('img[data-deferred-src]').forEach((image) => {
          if (image.dataset.deferredSrcset) {
            image.srcset = image.dataset.deferredSrcset;
            image.removeAttribute('data-deferred-srcset');
          }
          image.src = image.dataset.deferredSrc;
          image.removeAttribute('data-deferred-src');
        });
      }

      prepareSlideImages(slide, priority = 'auto') {
        const images = Array.from(
          slide.querySelectorAll('.nks-collection-hero__sign-image, .nks-collection-hero__image')
        ).filter((image) => window.getComputedStyle(image).display !== 'none');
        const pendingImages = images.map((image) => {
          const hasDeferredSource = Boolean(image.closest('picture')?.querySelector('source[data-deferred-srcset]'));
          const hasDeferredImage = image.hasAttribute('data-deferred-src');
          const isReady = () => (
            image.complete &&
            image.naturalWidth > 1 &&
            Boolean(image.currentSrc) &&
            !image.currentSrc.startsWith('data:')
          );
          if (!hasDeferredSource && !hasDeferredImage && isReady()) {
            return Promise.resolve(true);
          }

          return new Promise((resolve) => {
            let timeoutId;
            const finish = (ready) => {
              window.clearTimeout(timeoutId);
              image.removeEventListener('load', onLoad);
              image.removeEventListener('error', onError);
              resolve(ready);
            };
            const onLoad = () => finish(isReady());
            const onError = () => finish(false);
            image.addEventListener('load', onLoad, { once: true });
            image.addEventListener('error', onError, { once: true });
            timeoutId = window.setTimeout(() => finish(isReady()), 5000);
          });
        });

        this.loadSlideImages(slide, priority);
        return Promise.all(pendingImages).then((results) => results.every(Boolean));
      }

      scheduleNextSlideWarmup() {
        window.clearTimeout(this.imageWarmupTimer);
        if (this.slides.length < 2) return;

        this.imageWarmupTimer = window.setTimeout(() => {
          const nextIndex = (this.currentIndex + 1) % this.slides.length;
          this.prepareSlideImages(this.slides[nextIndex], 'low');
        }, 500);
      }

      async show(index, announce) {
        const normalizedIndex = (index + this.slides.length) % this.slides.length;
        const targetSlide = this.slides[normalizedIndex];
        const requestId = ++this.showRequestId;

        targetSlide.setAttribute('aria-busy', 'true');
        const imagesReady = await this.prepareSlideImages(targetSlide, 'high');
        targetSlide.removeAttribute('aria-busy');
        if (requestId !== this.showRequestId) return false;
        this.currentIndex = normalizedIndex;

        this.slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === normalizedIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
          slide.toggleAttribute('inert', !isActive);
          slide.querySelectorAll('[data-slide-link]').forEach((link) => {
            if (isActive) link.removeAttribute('tabindex');
            else link.setAttribute('tabindex', '-1');
          });
        });

        this.dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === normalizedIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-pressed', String(isActive));
        });

        if (announce && this.status) {
          const heading = this.slides[normalizedIndex].querySelector('.nks-collection-hero__heading')?.textContent?.trim() || '';
          this.status.textContent = `${normalizedIndex + 1} / ${this.slides.length}: ${heading}`;
        }

        if (announce) this.restartAutoplay();
        this.scheduleNextSlideWarmup();
        return true;
      }

      startAutoplay() {
        const isMobile = this.mobileViewport.matches;
        const autoplayEnabled = isMobile ? this.mobileAutoplayEnabled : this.autoplayEnabled;
        if (
          !autoplayEnabled ||
          this.pausedByUser ||
          (this.isHovered && !isMobile) ||
          this.hasFocus ||
          document.hidden ||
          window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ) return;
        this.stopAutoplay();
        const interval = isMobile ? this.mobileInterval : this.interval;
        this.timer = window.setInterval(() => this.show(this.currentIndex + 1, false), interval);
      }

      stopAutoplay() {
        if (!this.timer) return;
        window.clearInterval(this.timer);
        this.timer = null;
      }

      restartAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
      }

      toggleAutoplay() {
        this.pausedByUser = !this.pausedByUser;
        if (document.activeElement === this.autoplayButton) this.hasFocus = false;
        this.autoplayButton.classList.toggle('is-paused', this.pausedByUser);
        this.autoplayButton.setAttribute(
          'aria-label',
          this.pausedByUser ? this.autoplayButton.dataset.playLabel : this.autoplayButton.dataset.pauseLabel
        );
        if (this.pausedByUser) this.stopAutoplay();
        else this.startAutoplay();
      }
    }

    customElements.define('nks-collection-hero-slider', NksCollectionHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nks-collection-navigation"] && !Shopify.designMode) return;
  try {
    
  const initializeNksCollectionCarousel = (scope = document) => {
    scope.querySelectorAll('.nks-collection-nav').forEach((root) => {
      if (root.dataset.carouselBound === 'true') return;
      root.dataset.carouselBound = 'true';

      const track = root.querySelector('[data-nks-collection-track]');
      const previous = root.querySelector('[data-nks-collection-prev]');
      const next = root.querySelector('[data-nks-collection-next]');
      if (!track || !previous || !next) return;

      const movement = () => Math.max(track.clientWidth * 0.82, 280);
      const move = (direction) => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const atEnd = track.scrollLeft >= maxScroll - 8;
        const atStart = track.scrollLeft <= 8;

        if (direction > 0 && atEnd) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else if (direction < 0 && atStart) {
          track.scrollTo({ left: maxScroll, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: movement() * direction, behavior: 'smooth' });
        }
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        let paused = false;
        let timer = window.setInterval(() => {
          if (!paused && document.visibilityState === 'visible') move(1);
        }, 4200);

        const pause = () => { paused = true; };
        const resume = () => { paused = false; };
        root.addEventListener('pointerenter', pause);
        root.addEventListener('pointerleave', resume);
        root.addEventListener('focusin', pause);
        root.addEventListener('focusout', resume);
        root.addEventListener('touchstart', pause, { passive: true });
        root.addEventListener('touchend', resume, { passive: true });
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.target.contains(root)) window.clearInterval(timer);
        }, { once: true });
      }
    });
  };

  initializeNksCollectionCarousel();
  document.addEventListener('shopify:section:load', (event) => initializeNksCollectionCarousel(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nks-fastsigns-home"]) return;
  try {
    
if (!customElements.get('nks-fastsigns-stream')) {
  customElements.define('nks-fastsigns-stream', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.grid = this.querySelector('#product-grid');
      this.pagination = this.querySelector('[data-catalog-pagination]');
      this.button = this.querySelector('[data-collection-load-more]');
      this.label = this.querySelector('[data-collection-load-label]');
      this.status = this.querySelector('[data-collection-load-status]');
      if (!this.grid || !this.pagination || !this.button || !this.label || !this.status) return;
      this.initialized = true;
      this.pageSize = Math.max(1, Number(this.dataset.pageSize) || 24);
      this.currentPage = Number(this.dataset.currentPage) || 1;
      this.nextUrl = this.dataset.nextUrl || '';
      this.defaultLabel = this.label.textContent;
      this.loadedUrls = new Set();
      this.seen = new Set();
      this.primaryCards = [];
      this.tailCards = [];
      Array.from(this.grid.querySelectorAll('[data-catalog-card]')).forEach(card => {
        const id = card.dataset.productId;
        if (!id || this.seen.has(id)) {
          card.remove();
          return;
        }
        this.seen.add(id);
        if (card.dataset.catalogSource === 'soardist') this.tailCards.push(card);
        else this.primaryCards.push(card);
      });
      this.visibleCount = this.primaryCards.concat(this.tailCards).filter(card => !card.hidden).length;
      this.onClick = () => this.loadNextPage();
      this.button.addEventListener('click', this.onClick);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting) && this.pagination.dataset.state === 'idle') this.loadNextPage();
        }, { rootMargin: '900px 0px', threshold: 0 });
        this.observer.observe(this.pagination);
      }
      this.updateState();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      window.cancelAnimationFrame(this.checkFrame);
      this.button?.removeEventListener('click', this.onClick);
      this.initialized = false;
    }

    updateState() {
      const localRemaining = this.primaryCards.some(card => card.hidden) || this.tailCards.some(card => card.hidden);
      const complete = !localRemaining && !this.nextUrl;
      this.pagination.dataset.state = complete ? 'complete' : 'idle';
      this.pagination.dataset.visibleCount = String(this.visibleCount);
      this.pagination.dataset.loadedCount = String(this.seen.size);
      this.pagination.dataset.currentPage = String(this.currentPage);
      this.dataset.nextUrl = this.nextUrl;
      if (complete) this.observer?.disconnect();
    }

    reveal(cards, limit) {
      let count = 0;
      for (const card of cards) {
        if (!card.hidden) continue;
        card.classList.remove('scroll-trigger--offscreen');
        card.classList.add('scroll-trigger--cancel');
        card.hidden = false;
        this.visibleCount += 1;
        count += 1;
        if (count === limit) break;
      }
      return count;
    }

    async appendPublicPage() {
      const url = new URL(this.nextUrl, window.location.href);
      const normalizePath = path => path.replace(/\/$/, '');
      if (url.origin !== window.location.origin || normalizePath(url.pathname) !== normalizePath(window.location.pathname)) throw new Error('Catalog page unavailable');
      url.searchParams.set('section_id', this.dataset.sectionId);
      if (this.loadedUrls.has(url.href)) throw new Error('Catalog page did not advance');
      this.controller = new AbortController();
      const timeout = window.setTimeout(() => this.controller.abort(), 12000);
      try {
        const response = await fetch(url.href, {
          credentials: 'same-origin',
          headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
          signal: this.controller.signal
        });
        if (!response.ok) throw new Error('Catalog page unavailable');
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const stream = parsed.querySelector('nks-fastsigns-stream');
        const nextGrid = stream?.querySelector('#product-grid');
        const nextPage = Number(stream?.dataset.currentPage);
        if (!stream || !nextGrid || stream.dataset.sectionId !== this.dataset.sectionId || !Number.isInteger(nextPage) || nextPage !== this.currentPage + 1) throw new Error('Catalog page did not advance');
        if (!this.isConnected) return;
        const fragment = document.createDocumentFragment();
        Array.from(nextGrid.querySelectorAll('[data-catalog-card]')).forEach(card => {
          const id = card.dataset.productId;
          if (!id || card.dataset.catalogSource !== 'nks' || this.seen.has(id)) return;
          this.seen.add(id);
          card.hidden = true;
          card.classList.remove('scroll-trigger--offscreen');
          card.classList.add('scroll-trigger--cancel');
          this.primaryCards.push(card);
          fragment.appendChild(card);
        });
        const firstTail = this.tailCards.find(card => card.parentElement === this.grid);
        this.grid.insertBefore(fragment, firstTail || null);
        this.loadedUrls.add(url.href);
        this.currentPage = nextPage;
        this.nextUrl = stream.dataset.nextUrl || '';
      } finally {
        window.clearTimeout(timeout);
      }
    }

    async loadNextPage() {
      if (!this.isConnected || !['idle', 'retry'].includes(this.pagination.dataset.state)) return;
      this.pagination.dataset.state = 'loading';
      this.grid.setAttribute('aria-busy', 'true');
      this.button.disabled = true;
      this.label.textContent = this.pagination.dataset.labelLoading;
      this.status.textContent = this.pagination.dataset.labelLoading;
      const start = this.visibleCount;
      try {
        let remaining = this.pageSize;
        while (remaining > 0 && this.isConnected) {
          remaining -= this.reveal(this.primaryCards, remaining);
          if (remaining === 0) break;
          if (this.nextUrl) {
            await this.appendPublicPage();
          } else {
            this.reveal(this.tailCards, remaining);
            break;
          }
        }
        if (!this.isConnected) return;
        this.updateState();
        this.label.textContent = this.defaultLabel;
        this.status.textContent = this.pagination.dataset.state === 'complete'
          ? this.pagination.dataset.labelComplete
          : this.pagination.dataset.labelLoaded.replace('__COUNT__', String(this.visibleCount - start));
      } catch (error) {
        if (!this.isConnected) return;
        this.pagination.dataset.state = 'retry';
        this.label.textContent = this.pagination.dataset.labelRetry;
        this.status.textContent = this.pagination.dataset.labelRetry;
      } finally {
        this.grid.setAttribute('aria-busy', 'false');
        this.button.disabled = false;
        this.pagination.dataset.visibleCount = String(this.visibleCount);
        if (this.isConnected && this.pagination.dataset.state === 'idle') {
          this.checkFrame = window.requestAnimationFrame(() => {
            const rect = this.pagination.getBoundingClientRect();
            if (rect.top < window.innerHeight + 900 && rect.bottom > -900) this.loadNextPage();
          });
        }
      }
    }
  });
}


  const initializeNksFastsignsCollectionCarousel = (scope = document) => {
    scope.querySelectorAll('[data-fastsigns-private-home] .nks-collection-nav').forEach((root) => {
      if (root.dataset.carouselBound === 'true') return;
      root.dataset.carouselBound = 'true';

      const track = root.querySelector('[data-nks-collection-track]');
      const previous = root.querySelector('[data-nks-collection-prev]');
      const next = root.querySelector('[data-nks-collection-next]');
      if (!track || !previous || !next) return;

      const movement = () => Math.max(track.clientWidth * 0.82, 280);
      const move = (direction) => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const atEnd = track.scrollLeft >= maxScroll - 8;
        const atStart = track.scrollLeft <= 8;

        if (direction > 0 && atEnd) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else if (direction < 0 && atStart) {
          track.scrollTo({ left: maxScroll, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: movement() * direction, behavior: 'smooth' });
        }
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        let paused = false;
        let timer = window.setInterval(() => {
          if (!paused && document.visibilityState === 'visible') move(1);
        }, 4200);

        const pause = () => { paused = true; };
        const resume = () => { paused = false; };
        root.addEventListener('pointerenter', pause);
        root.addEventListener('pointerleave', resume);
        root.addEventListener('focusin', pause);
        root.addEventListener('focusout', resume);
        root.addEventListener('touchstart', pause, { passive: true });
        root.addEventListener('touchend', resume, { passive: true });
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.target.contains(root)) window.clearInterval(timer);
        }, { once: true });
      }
    });
  };

  initializeNksFastsignsCollectionCarousel();
  document.addEventListener('shopify:section:load', (event) => initializeNksFastsignsCollectionCarousel(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nks-franchise-plans"] && !Shopify.designMode) return;
  try {
    
function initNksFranchise(root) {
  if (root.dataset.fpReady) return;
  const model = JSON.parse(root.querySelector('[data-fp-model]').textContent);
  const ui = JSON.parse(root.querySelector('[data-fp-i18n]').textContent);
  const query = new URLSearchParams(location.search);
  const productHandle = root.dataset.productHandle;
  let plan = model.plans.find(p => p.handle === productHandle);
  if (productHandle && !plan) {
    root.querySelector('[data-fp-content]').hidden = true;
    root.querySelector('[data-fp-unavailable]').hidden = false;
    return;
  }
  plan = plan || model.plans.find(p => p.key === query.get('fp_plan')) || model.plans.find(p => p.key === root.dataset.initialPlan) || model.plans[0];
  const option = (key, max) => { const n = Number(query.get('fp_' + key) || 0); return Number.isInteger(n) && n >= 0 && n <= max ? n : 0; };
  const state = { brand:option('brand',1), scope:option('scope',1), service:option('service',2) };
  const requestedVariant = query.get('variant');
  const initialVariant = plan.variants.find(v => v.id === requestedVariant);
  if (initialVariant) Object.assign(state,{brand:initialVariant.brand,scope:initialVariant.scope,service:initialVariant.service});
  const currency = new Intl.NumberFormat(root.dataset.language.startsWith('es') ? 'es-US' : 'en-US', {style:'currency',currency:'USD',maximumFractionDigits:0});
  const money = n => 'US' + currency.format(n);
  const storeLabel = n => n === 1 ? ui.one_store : ui.stores.replace('[count]',String(n));
  const serviceLabels = [ui.essential,ui.growth,ui.managed];
  const brandLabels = [ui.own_brand,ui.nks_brand];
  const text = (selector,value) => root.querySelector(selector).textContent = value;
  const nativeRoutes = root.dataset.nativeRoutes === 'true';
  const pageUrl = (view, targetPlan = plan) => {
    const comparing = view === 'franchise-plans';
    const path = nativeRoutes ? (comparing ? root.dataset.collectionPath : root.dataset.productPath + targetPlan.handle) : root.dataset.reviewPath;
    const url = new URL(path,location.origin);
    if (!nativeRoutes) {
      if (!nativeRoutes) url.searchParams.set('preview_theme_id',root.dataset.previewThemeId);
      url.searchParams.set('view',comparing ? 'franchise-collection' : view);
    }
    url.searchParams.set('fp_plan',targetPlan.key);
    Object.keys(state).forEach(key=>url.searchParams.set('fp_'+key,state[key]));
    if (nativeRoutes && !comparing) {
      const variant = targetPlan.variants.find(v=>v.brand===state.brand && v.scope===state.scope && v.service===state.service);
      if (variant) url.searchParams.set('variant',variant.id);
    }
    return url.href;
  };
  function update(syncUrl) {
    const v = plan.variants.find(x=>x.brand===state.brand && x.scope===state.scope && x.service===state.service);
    if (!v) { text('[data-fp-feedback]',ui.unavailable); return; }
    root.querySelectorAll('[data-fp-plan]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.fpPlan===plan.key)));
    root.querySelectorAll('[data-fp-option]').forEach(input=>input.checked=Number(input.value)===state[input.dataset.fpOption]);
    text('[data-fp-plan-title]',ui.plan.replace('[name]',plan.name));
    text('[data-fp-entry-title]',productHandle ? ui.plan.replace('[name]',plan.name) : ui.entry_title);
    text('[data-fp-selection-line]',brandLabels[state.brand]+' · '+storeLabel(v.shops)+' · '+serviceLabels[state.service]);
    text('[data-fp-scope-label="0"]',storeLabel(plan.shops));
    text('[data-fp-scope-label="1"]',storeLabel(plan.expandedShops));
    text('[data-fp-service-note]',[ui.essential_note,ui.growth_note,ui.managed_note][state.service]);
    text('[data-fp-brand-name]',brandLabels[state.brand]);
    text('[data-fp-price]',money(v.price));
    text('[data-fp-entry]',money(v.entry));
    text('[data-fp-setup]',money(v.setup));
    text('[data-fp-monthly]',money(v.monthly)+ui.per_month);
    text('[data-fp-share]',v.share+'%');
    text('[data-fp-sku]',v.sku);
    text('[data-fp-feedback]','');
    const summary = root.querySelector('[data-fp-summary]');
    summary.replaceChildren();
    [ui.plan.replace('[name]',plan.name),brandLabels[state.brand]+' · '+storeLabel(v.shops)+' · '+serviceLabels[state.service],money(v.price)+' · '+money(v.monthly)+ui.per_month+' · '+v.share+'%',v.sku].forEach((line,index)=>{
      const node=document.createElement(index===0?'strong':'span');node.textContent=line;summary.append(node);
    });
    const configuration=[ui.plan.replace('[name]',plan.name),brandLabels[state.brand]+' / '+storeLabel(v.shops)+' / '+serviceLabels[state.service],ui.initial+': '+money(v.price),ui.monthly+': '+money(v.monthly)+ui.per_month,ui.share+': '+v.share+'%',v.sku].join('\n');
    const fields={plan:plan.name,variant_id:v.id,sku:v.sku,configuration,initial:v.price,monthly:v.monthly,share:v.share+'% of eligible net collected sales (proposal)'};
    root.querySelectorAll('[data-fp-field]').forEach(input=>{
      const value=String(fields[input.dataset.fpField] ?? '');
      input.value=value;
      if(input.tagName==='INPUT')input.setAttribute('value',value);
    });
    root.querySelector('[data-fp-page]').href=pageUrl('franchise-plan-'+plan.key);
    root.querySelector('[data-fp-compare]').href=pageUrl('franchise-plans');
    root.querySelectorAll('[data-fp-plan-link]').forEach(link=>{
      const targetPlan=model.plans.find(p=>p.key===link.dataset.fpPlanLink);
      link.href=pageUrl('franchise-plan-'+targetPlan.key,targetPlan);
    });
    if(syncUrl){
      const url=new URL(location.href);
      if (!nativeRoutes) url.searchParams.set('preview_theme_id',root.dataset.previewThemeId);
      url.searchParams.set('fp_plan',plan.key);
      Object.keys(state).forEach(key=>url.searchParams.set('fp_'+key,state[key]));
      if (nativeRoutes && productHandle === plan.handle) url.searchParams.set('variant',v.id);
      else url.searchParams.delete('variant');
      history.replaceState(null,'',url);
    }
  }
  root.addEventListener('change',event=>{
    if(event.target.matches('[data-fp-option]')){state[event.target.dataset.fpOption]=Number(event.target.value);update(true);}
  });
  root.addEventListener('click',event=>{
    const button=event.target.closest('[data-fp-plan]');
    if(button){
      const targetPlan=model.plans.find(p=>p.key===button.dataset.fpPlan);
      if(nativeRoutes && productHandle && targetPlan.handle !== productHandle){
        location.assign(pageUrl('franchise-plan-'+targetPlan.key,targetPlan));
        return;
      }
      const next=()=>{plan=model.plans.find(p=>p.key===button.dataset.fpPlan);update(true);};
      if(document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) document.startViewTransition(next); else next();
    }
  });
  root.querySelector('[data-fp-select]').addEventListener('click',()=>{
    root.querySelector('[data-fp-confirmation]').open=true;
    const target=root.querySelector('[name="contact[name]"]');
    target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});
    setTimeout(()=>target.focus({preventScroll:true}),250);
  });
  const send=root.querySelector('[data-fp-send]');
  if(matchMedia('(max-width: 600px)').matches)root.querySelector('[data-fp-options-panel]').open=false;
  if([...root.querySelectorAll('[data-fp-confirmation] [role="status"], [data-fp-confirmation] [role="alert"]')].some(node=>node.textContent.trim()))root.querySelector('[data-fp-confirmation]').open=true;
  root.dataset.fpReady='true';
  root.querySelector('[data-fp-select]').disabled=false;
  send.disabled=false;
  update(false);
}
function mountNksFranchise(){document.querySelectorAll('[data-fp-root]').forEach(initNksFranchise);}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',mountNksFranchise); else mountNksFranchise();
document.addEventListener('shopify:section:load',mountNksFranchise);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nks-letters-quote"] && !Shopify.designMode) return;
  try {
    
const NKSLettersQuoteEngine=(()=>{
  const fonts=['Arial','Arial Bold','Helvetica','Futura','Times New Roman','Brush Script'];
  const families={'Arial':'Arial, sans-serif','Arial Bold':'Arial, sans-serif','Helvetica':'Helvetica, Arial, sans-serif','Futura':'Futura, Trebuchet MS, sans-serif','Times New Roman':'Times New Roman, serif','Brush Script':'Brush Script MT, Segoe Script, cursive'};
  const count=value=>{const n=Number(value);if(!Number.isInteger(n)||n<1||n>99)throw new Error('invalid_quantity');return n;};
  const color=value=>{if(!/^#[0-9a-f]{6}$/i.test(value))throw new Error('invalid_color');return value.toLowerCase();};
  const word=value=>{const w=String(value).normalize('NFC');if(!w.trim()||Array.from(w).length>40||!/^[A-Za-z0-9Ññ ]+$/.test(w))throw new Error('invalid_word');return w;};
  const validate=p=>{
    if(!/^[A-Z0-9Ñ]$/.test(p.glyph)||!fonts.includes(p.font)||!['Uppercase','Lowercase'].includes(p.letterCase)||!['Unlit','Backlit'].includes(p.lighting))throw new Error('invalid_piece');
    if(/[0-9]/.test(p.glyph)&&p.letterCase!=='Uppercase')throw new Error('invalid_piece');
    color(p.color);count(p.quantity);return p;
  };
  const pieces=(text,defaults)=>Array.from(word(text)).map((char,i)=>char===' '?null:validate({
    glyph:char.toUpperCase(),position:i+1,font:defaults.font,letterCase:/[0-9]/.test(char)?'Uppercase':defaults.letterCase,color:color(defaults.color),lighting:defaults.lighting,quantity:1
  })).filter(Boolean);
  const display=p=>p.letterCase==='Lowercase'?p.glyph.toLowerCase():p.glyph;
  const evaluate=(text,selected,sets)=>{
    const w=word(text);const q=count(sets);const chars=Array.from(w);const seen=new Set();
    if(selected.length!==chars.filter(c=>c!==' ').length)throw new Error('invalid_layout');
    selected.forEach(p=>{validate(p);if(!Number.isInteger(p.position)||p.position<1||p.position>chars.length||chars[p.position-1].toUpperCase()!==p.glyph||seen.has(p.position))throw new Error('invalid_layout');seen.add(p.position);});
    const preview=chars.map((char,i)=>char===' '?' ':display(selected.find(p=>p.position===i+1))).join('');
    const lines=selected.map(p=>({position:p.position,glyph:p.glyph,display:display(p),font:p.font,letterCase:/[0-9]/.test(p.glyph)?null:p.letterCase,color:color(p.color),lighting:p.lighting,perSet:count(p.quantity),total:count(p.quantity)*q}));
    const totals={};lines.forEach(l=>{totals[l.glyph]=(totals[l.glyph]||0)+l.total;});
    return {requestedText:w,previewText:preview,sets:q,lines,totals,totalPieces:lines.reduce((sum,l)=>sum+l.total,0)};
  };
  const quote=(text,selected,sets,group)=>{
    if(!group||group.length>80)throw new Error('invalid_group');
    const r=evaluate(text,selected,sets);
    return JSON.stringify({
      request_group:group,requested_text:r.requestedText,concept_preview_text:r.previewText,sets_requested:r.sets,
      pieces:r.lines.map(l=>({position:l.position,character:l.glyph,display_character:l.display,font_requested:l.font,letter_case_requested:l.letterCase,color_hex_requested:l.color,lighting_requested:l.lighting,quantity_per_set:l.perSet,total_requested:l.total,requires_fabrication_confirmation:true})),
      character_totals:r.totals,total_pieces_requested:r.totalPieces,preview_is_concept:true,requires_complete_quote:true,
      order_created:false,invoice_created:false,account_balance_created:false
    },null,2);
  };
  return {fonts,families,count,color,word,validate,pieces,display,evaluate,quote};
})();
if(typeof module!=='undefined'&&module.exports)module.exports=NKSLettersQuoteEngine;
if(typeof window!=='undefined'){
  window.NKSLettersQuoteEngine=NKSLettersQuoteEngine;
  if(!customElements.get('nks-letters-quote'))customElements.define('nks-letters-quote',class extends HTMLElement{
    connectedCallback(){
      if(this.initialized)return;this.initialized=true;
      this.labels=JSON.parse(this.querySelector('[data-letter-quote-labels]').textContent);
      this.group='letters-quote-'+(crypto.randomUUID?crypto.randomUUID():String(Date.now())+'-'+Math.random().toString(36).slice(2));
      this.querySelector('[data-build-word]').addEventListener('click',()=>this.build());
      this.querySelector('[data-word]').addEventListener('input',()=>{this.dirty=true;this.fail();});
      this.querySelector('[data-word]').addEventListener('keydown',e=>{if(e.key==='Enter'){e.preventDefault();this.build();}});
      this.addEventListener('click',e=>{
        if(e.target.dataset.glyph){this.querySelector('[data-word]').value+=e.target.dataset.glyph;this.build();}
        if(e.target.closest('[data-open-letter-quote]')&&this.valid){
          this.querySelector('[data-quote-panel]').open=true;
          const email=this.querySelector('[name="contact[email]"]');
          email.scrollIntoView({block:'center',behavior:'smooth'});email.focus({preventScroll:true});
        }
      });
      this.addEventListener('change',e=>{
        const row=e.target.closest('[data-piece-position]');
        if(row){
          const piece=this.selected.find(p=>String(p.position)===row.dataset.piecePosition);
          piece.font=row.querySelector('[data-piece-font]').value;piece.letterCase=row.querySelector('[data-piece-case]')?.value||'Uppercase';
          piece.color=row.querySelector('[data-piece-color]').value;piece.lighting=row.querySelector('[data-piece-lighting]').value;piece.quantity=row.querySelector('[data-piece-quantity]').value;
          this.update();
        }else if(e.target.matches('[data-sets]'))this.update();
        else if(e.target.matches('[data-default-font],[data-default-case],[data-default-color],[data-default-lighting]'))this.build();
      });
      this.addEventListener('input',e=>{if(e.target.matches('[data-sets],[data-piece-quantity]'))this.updatePieceQuantity(e.target);});
      this.querySelector('form').addEventListener('submit',e=>{this.update();if(!this.valid)e.preventDefault();});
      this.build();
    }
    defaults(){return {font:this.querySelector('[data-default-font]').value,letterCase:this.querySelector('[data-default-case]').value,color:this.querySelector('[data-default-color]').value,lighting:this.querySelector('[data-default-lighting]').value};}
    create(tag,text){const el=document.createElement(tag);if(text)el.textContent=text;return el;}
    field(row,p,key,label,options,current){
      const id=this.group+'-'+p.position+'-'+key;const title=this.create('label',label);title.htmlFor=id;row.append(title);
      const select=this.create('select');select.id=id;select.dataset[key]='';
      options.forEach(o=>{const option=this.create('option',o[1]);option.value=o[0];select.append(option);});select.value=current;row.append(select);
    }
    build(){
      try{
        this.text=NKSLettersQuoteEngine.word(this.querySelector('[data-word]').value);
        this.querySelector('[data-word]').value=this.text;this.selected=NKSLettersQuoteEngine.pieces(this.text,this.defaults());this.dirty=false;
        const rows=this.querySelector('[data-pieces]');rows.replaceChildren();
        this.selected.forEach(p=>{
          const row=this.create('div');row.className='nks-letters-quote__piece';row.dataset.piecePosition=String(p.position);
          row.append(this.create('h2',this.labels.position+' '+p.position+' · '+p.glyph));
          this.field(row,p,'pieceFont',this.labels.font,NKSLettersQuoteEngine.fonts.map(f=>[f,f]),p.font);
          if(!/[0-9]/.test(p.glyph))this.field(row,p,'pieceCase',this.labels.case,[['Uppercase',this.labels.upper],['Lowercase',this.labels.lower]],p.letterCase);
          const colorId=this.group+'-'+p.position+'-color';const colorLabel=this.create('label',this.labels.color);colorLabel.htmlFor=colorId;row.append(colorLabel);
          const color=this.create('input');color.type='color';color.id=colorId;color.dataset.pieceColor='';color.value=p.color;row.append(color);
          this.field(row,p,'pieceLighting',this.labels.lighting,[['Unlit',this.labels.unlit],['Backlit',this.labels.backlit]],p.lighting);
          const qtyId=this.group+'-'+p.position+'-quantity';const qtyLabel=this.create('label',this.labels.quantity);qtyLabel.htmlFor=qtyId;row.append(qtyLabel);
          const qty=this.create('input');qty.type='number';qty.min='1';qty.max='99';qty.value='1';qty.id=qtyId;qty.dataset.pieceQuantity='';qty.inputMode='numeric';row.append(qty);rows.append(row);
        });
        this.update();
      }catch(e){this.dirty=true;this.fail();}
    }
    updatePieceQuantity(target){
      const row=target.closest('[data-piece-position]');
      if(row){const p=this.selected.find(p=>String(p.position)===row.dataset.piecePosition);p.quantity=target.value;}
      this.update();
    }
    fail(){
      this.valid=false;this.querySelector('[data-letter-status]').textContent=this.labels.invalid;
      this.querySelector('[data-quote-payload]').value='';this.querySelector('[data-quote-text]').value='';
      this.querySelector('[data-send-quote]').disabled=true;this.querySelector('[data-open-letter-quote]').disabled=true;
    }
    update(){
      if(this.dirty){this.fail();return;}
      try{
        const r=NKSLettersQuoteEngine.evaluate(this.text,this.selected,this.querySelector('[data-sets]').value);this.result=r;
        const preview=this.querySelector('[data-word-preview]');preview.replaceChildren();
        Array.from(this.text).forEach((char,i)=>{
          const p=this.selected.find(p=>p.position===i+1);const span=this.create('span',p?NKSLettersQuoteEngine.display(p):' ');
          if(p){span.style.fontFamily=NKSLettersQuoteEngine.families[p.font];span.style.fontWeight=p.font==='Arial Bold'?'700':'400';span.style.color=NKSLettersQuoteEngine.color(p.color);span.classList.toggle('is-backlit',p.lighting==='Backlit');}
          else span.style.width='.6em';preview.append(span);
        });
        this.querySelector('[data-piece-count]').textContent=this.labels.total+' '+r.totalPieces;
        const lines=this.querySelector('[data-summary-lines]');lines.replaceChildren(...r.lines.map(l=>this.create('li',l.position+'. '+l.display+' · '+l.font+' · '+l.color+' · '+(l.lighting==='Backlit'?this.labels.backlit:this.labels.unlit)+' · '+this.labels.requested+': '+l.total)));
        const human=r.previewText+'\n'+this.labels.sets+': '+r.sets+'\n'+r.lines.map(l=>l.position+'. '+l.display+' · '+l.font+' · '+l.color+' · '+(l.lighting==='Backlit'?this.labels.backlit:this.labels.unlit)+' · '+this.labels.quantity+': '+l.perSet+' · '+this.labels.requested+': '+l.total).join('\n')+'\n'+this.labels.pending;
        this.querySelector('[data-quote-text]').value=human;this.querySelector('[data-quote-payload]').value=NKSLettersQuoteEngine.quote(this.text,this.selected,r.sets,this.group);
        this.querySelector('[data-letter-status]').textContent=this.labels.pending;this.querySelector('[data-send-quote]').disabled=false;this.querySelector('[data-open-letter-quote]').disabled=false;this.valid=true;
      }catch(e){this.fail();}
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nks-private-wholesale"]) return;
  try {
    
if (!customElements.get('nks-private-collection')) {
  customElements.define('nks-private-collection', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.grid = this.querySelector('#product-grid');
      if (!this.grid) return;
      this.initialized = true;
      this.cards = Array.from(this.grid.querySelectorAll('[data-catalog-card]'));
      this.pageSize = Math.max(1, Number(this.dataset.pageSize) || 24);
      this.pagination = this.querySelector('[data-catalog-pagination]');
      this.button = this.querySelector('[data-collection-load-more]');
      this.label = this.querySelector('[data-collection-load-label]');
      this.status = this.querySelector('[data-collection-load-status]');
      this.defaultLabel = this.label?.textContent || '';
      this.filterState = { available: new Set(), min: '', max: '', sort: 'manual' };
      this.onChange = event => {
        const input = event.target;
        if (!input.matches('[data-catalog-filter]')) return;
        if (input.dataset.catalogFilter === 'availability') {
          if (input.checked) this.filterState.available.add(input.value);
          else this.filterState.available.delete(input.value);
        } else {
          this.filterState[input.dataset.catalogFilter] = input.value;
        }
        this.syncInputs();
        this.applyFilters();
      };
      this.onClick = event => {
        const reset = event.target.closest('[data-catalog-reset]');
        if (reset) {
          event.preventDefault();
          const type = reset.dataset.catalogReset;
          if (type === 'availability' || type === 'all') this.filterState.available.clear();
          if (type === 'price' || type === 'all') {
            this.filterState.min = '';
            this.filterState.max = '';
          }
          this.syncInputs();
          this.applyFilters();
          return;
        }
        if (event.target.closest('[data-collection-load-more]')) this.loadNextPage();
        if (event.target.closest('[data-catalog-apply]')) {
          this.querySelector('.mobile-facets__wrapper > details > summary')?.click();
        }
      };
      this.onSubmit = event => {
        if (event.target.matches('[data-catalog-filters-form]')) event.preventDefault();
      };
      this.addEventListener('change', this.onChange);
      this.addEventListener('click', this.onClick);
      this.addEventListener('submit', this.onSubmit);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting) && this.pagination.dataset.state === 'idle') this.loadNextPage();
        }, { rootMargin: '900px 0px', threshold: 0 });
      }
      this.applyFilters();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      window.cancelAnimationFrame(this.frame);
      window.cancelAnimationFrame(this.checkFrame);
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('submit', this.onSubmit);
      this.initialized = false;
    }

    syncInputs() {
      this.querySelectorAll('[data-catalog-filter]').forEach(input => {
        const type = input.dataset.catalogFilter;
        if (type === 'availability') input.checked = this.filterState.available.has(input.value);
        else input.value = this.filterState[type];
        input.closest('.facets__label')?.classList.toggle('active', input.checked === true);
      });
    }

    matchesPrice(card) {
      const price = Number(card.dataset.catalogPrice);
      const min = this.filterState.min === '' ? null : Number(this.filterState.min) * 100;
      const max = this.filterState.max === '' ? null : Number(this.filterState.max) * 100;
      return (min === null || price >= min) && (max === null || price <= max);
    }

    applyFilters() {
      window.cancelAnimationFrame(this.frame);
      window.cancelAnimationFrame(this.checkFrame);
      const availableCounts = { true: 0, false: 0 };
      this.matches = this.cards.filter(card => {
        if (!this.matchesPrice(card)) return false;
        const availability = card.dataset.catalogAvailable;
        availableCounts[availability] += 1;
        return this.filterState.available.size === 0 || this.filterState.available.has(availability);
      });
      const numberSort = (key, direction) => (a, b) => direction * (Number(a.dataset[key]) - Number(b.dataset[key])) || Number(a.dataset.catalogOrder) - Number(b.dataset.catalogOrder);
      const sorts = {
        manual: numberSort('catalogOrder', 1),
        'price-ascending': numberSort('catalogPrice', 1),
        'price-descending': numberSort('catalogPrice', -1),
        'title-ascending': (a, b) => a.dataset.catalogTitle.localeCompare(b.dataset.catalogTitle, document.documentElement.lang, { sensitivity: 'base', numeric: true }),
        'title-descending': (a, b) => b.dataset.catalogTitle.localeCompare(a.dataset.catalogTitle, document.documentElement.lang, { sensitivity: 'base', numeric: true }),
        'created-ascending': numberSort('catalogCreated', 1),
        'created-descending': numberSort('catalogCreated', -1)
      };
      this.matches.sort(sorts[this.filterState.sort] || sorts.manual);
      this.cards.forEach(card => { card.hidden = true; });
      const fragment = document.createDocumentFragment();
      this.matches.forEach(card => fragment.appendChild(card));
      this.grid.appendChild(fragment);
      this.visibleCount = Math.min(this.pageSize, this.matches.length);
      this.matches.slice(0, this.visibleCount).forEach(card => {
        card.hidden = false;
        if (this.filterState.sort !== 'manual' || Number(card.dataset.catalogOrder) > this.pageSize) card.classList.add('scroll-trigger--cancel');
      });
      const countLabel = this.matches.length === 1 ? this.dataset.countLabelOne : this.dataset.countLabel;
      this.querySelectorAll('[data-catalog-count]').forEach(node => {
        node.textContent = countLabel.replace('__COUNT__', String(this.matches.length));
      });
      this.querySelectorAll('[data-catalog-availability-count]').forEach(node => {
        node.textContent = String(availableCounts[node.dataset.catalogAvailabilityCount]);
      });
      this.querySelectorAll('[data-catalog-filter="availability"]').forEach(input => {
        input.disabled = availableCounts[input.value] === 0 && !input.checked;
        input.closest('.facets__label')?.classList.toggle('disabled', input.disabled);
      });
      this.querySelectorAll('[data-catalog-reset-all]').forEach(node => {
        node.hidden = this.filterState.available.size === 0 && this.filterState.min === '' && this.filterState.max === '';
      });
      this.querySelector('[data-catalog-empty]').hidden = this.matches.length > 0;
      this.grid.setAttribute('aria-busy', 'false');
      this.button.disabled = false;
      this.label.textContent = this.defaultLabel;
      this.pagination.dataset.state = this.visibleCount < this.matches.length ? 'idle' : 'complete';
      this.pagination.dataset.currentPage = '1';
      this.pagination.dataset.visibleCount = String(this.visibleCount);
      this.pagination.dataset.totalCount = String(this.matches.length);
      this.observer?.unobserve(this.pagination);
      this.observer?.observe(this.pagination);
    }

    loadNextPage() {
      if (!this.isConnected || this.pagination.dataset.state !== 'idle') return;
      this.pagination.dataset.state = 'loading';
      this.grid.setAttribute('aria-busy', 'true');
      this.button.disabled = true;
      this.label.textContent = this.pagination.dataset.labelLoading;
      this.status.textContent = this.pagination.dataset.labelLoading;
      this.frame = window.requestAnimationFrame(() => {
        if (!this.isConnected) return;
        const start = this.visibleCount;
        this.visibleCount = Math.min(start + this.pageSize, this.matches.length);
        this.matches.slice(start, this.visibleCount).forEach(card => {
          card.classList.add('scroll-trigger--cancel');
          card.hidden = false;
        });
        this.pagination.dataset.visibleCount = String(this.visibleCount);
        this.pagination.dataset.currentPage = String(Math.ceil(this.visibleCount / this.pageSize));
        this.pagination.dataset.state = this.visibleCount < this.matches.length ? 'idle' : 'complete';
        this.label.textContent = this.defaultLabel;
        this.status.textContent = this.pagination.dataset.state === 'complete'
          ? this.pagination.dataset.labelComplete
          : this.pagination.dataset.labelLoaded.replace('__COUNT__', String(this.visibleCount - start));
        this.grid.setAttribute('aria-busy', 'false');
        this.button.disabled = false;
        if (this.pagination.dataset.state === 'idle') {
          this.checkFrame = window.requestAnimationFrame(() => {
            const rect = this.pagination.getBoundingClientRect();
            if (rect.top < window.innerHeight + 900 && rect.bottom > -900) this.loadNextPage();
          });
        }
      });
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nks-project-estimator"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-nks-project-estimator]').forEach((estimator) => {
    if (estimator.dataset.initialized === 'true') return;
    estimator.dataset.initialized = 'true';

    const form = estimator.querySelector('form');
    const output = estimator.querySelector('[data-estimate-output]');
    const property = estimator.querySelector('[data-estimate-property]');
    const baseEstimate = Number(estimator.dataset.baseEstimate || 0);
    const buffer = Number(estimator.dataset.buffer || 0);
    const locale = estimator.dataset.locale || 'en-US';
    const currency = estimator.dataset.currency || 'USD';
    const formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      maximumFractionDigits: 0,
    });

    const format = (cents) => formatter.format(cents / 100);
    const update = () => {
      const checked = [...form.querySelectorAll('input[type="radio"][data-adjustment]:checked')];
      const adjustment = checked.reduce((sum, input) => sum + Number(input.dataset.adjustment || 0), 0);
      const low = baseEstimate + adjustment;
      const highRaw = low * (1 + buffer / 100);
      const high = Math.ceil(highRaw / 10000) * 10000;
      const range = `${format(low)}–${format(high)}`;
      output.textContent = range;
      property.value = range;
    };

    form.addEventListener('change', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nks-swipe-shop"]) return;
  try {
    
  if (!customElements.get('nks-swipe-shop')) {
    customElements.define('nks-swipe-shop', class extends HTMLElement {
      connectedCallback() {
        this.feed = this.querySelector('[data-swipe-feed]');
        if (!this.feed) return;
        this.profileKey = 'nksSwipeProfileV1';
        this.profile = { categories: {} };
        this.activeCard = null;
        this.activeSince = 0;
        this.canPersist = false;
        this.onboardingPlayed = false;
        this.onboardingToken = 0;
        this.onboardingDueAt = 0;
        this.onboardingInteracting = false;
        this.nextUrl = this.dataset.nextUrl || '';
        this.sectionId = this.dataset.sectionId || '';
        this.loadingMore = false;
        this.removeDuplicates();
        this.cards = [...this.querySelectorAll('[data-swipe-card]')];
        this.refreshConsent();
        document.addEventListener('visitorConsentCollected', () => this.refreshConsent());
        this.bindVariants(this.cards);
        this.bindActions(this.cards);
        this.observeCards(this.cards);
        this.bindOnboarding();
        this.bindDesktopNavigation();
        this.updateNavigation();
        if (!this.cards.length && this.nextUrl) this.loadMore();
      }

      disconnectedCallback() {
        clearTimeout(this.onboardingTimer);
        clearTimeout(this.viewTimer);
        clearTimeout(this.toastTimer);
        this.onboardingToken += 1;
        this.observer?.disconnect();
        document.removeEventListener('keydown', this.boundNavigationKey);
        this.feed?.removeEventListener('wheel', this.boundClearNavigation);
        this.feed?.removeEventListener('pointerdown', this.boundClearNavigation);
        this.querySelector('[data-swipe-previous]')?.removeEventListener('click', this.boundPreviousCard);
        this.querySelector('[data-swipe-next]')?.removeEventListener('click', this.boundNextCard);
        if (!this.boundCancelOnboarding) return;
        this.feed?.removeEventListener('pointerdown', this.boundCancelOnboarding);
        this.feed?.removeEventListener('touchstart', this.boundCancelOnboarding);
        this.feed?.removeEventListener('wheel', this.boundCancelOnboarding);
        this.feed?.removeEventListener('keydown', this.boundCancelOnboarding);
        this.feed?.removeEventListener('change', this.boundCancelOnboarding);
        this.feed?.removeEventListener('focusin', this.boundCancelOnboarding);
        this.feed?.removeEventListener('focusout', this.boundResumeOnboarding);
        this.feed?.removeEventListener('scroll', this.boundOnboardingScroll);
        window.removeEventListener('pointerup', this.boundResumeOnboarding);
        window.removeEventListener('pointercancel', this.boundResumeOnboarding);
        window.removeEventListener('touchend', this.boundResumeOnboarding);
        window.removeEventListener('touchcancel', this.boundResumeOnboarding);
        window.removeEventListener('resize', this.boundOnboardingResize);
        document.removeEventListener('visibilitychange', this.boundOnboardingVisibility);
        this.onboardingCueCard?.classList.remove('is-onboarding-cue');
        this.classList.remove('is-onboarding-active', 'is-onboarding-motion');
      }

      bindDesktopNavigation() {
        this.boundPreviousCard = () => this.moveCard(-1);
        this.boundNextCard = () => this.moveCard(1);
        this.querySelector('[data-swipe-previous]')?.addEventListener('click', this.boundPreviousCard);
        this.querySelector('[data-swipe-next]')?.addEventListener('click', this.boundNextCard);
        this.boundNavigationKey = (event) => {
          if (!window.matchMedia('(min-width: 750px)').matches || event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey) return;
          const focused = document.activeElement;
          if (focused?.closest('input, select, textarea, [contenteditable="true"], dialog, [role="dialog"], shopify-chat, [data-nks-menu-trigger]') || document.querySelector('header-drawer > details[open], dialog[open], [role="dialog"][aria-modal="true"]')) return;
          if (focused !== document.body && !this.contains(focused)) return;
          const direction = ['ArrowDown', 'ArrowRight', 'PageDown'].includes(event.key) ? 1 : ['ArrowUp', 'ArrowLeft', 'PageUp'].includes(event.key) ? -1 : 0;
          if (!direction) return;
          event.preventDefault();
          this.moveCard(direction);
        };
        document.addEventListener('keydown', this.boundNavigationKey);
        this.boundClearNavigation = () => { this.pendingNavigationCard = null; };
        this.feed.addEventListener('wheel', this.boundClearNavigation, { passive: true });
        this.feed.addEventListener('pointerdown', this.boundClearNavigation, { passive: true });
      }

      updateNavigation() {
        const index = Math.max(0, this.cards.indexOf(this.activeCard || this.cards[0]));
        const previous = this.querySelector('[data-swipe-previous]');
        const next = this.querySelector('[data-swipe-next]');
        const position = this.querySelector('[data-swipe-position]');
        const empty = this.querySelector('[data-swipe-empty]');
        if (previous) previous.disabled = index === 0 || !this.cards.length;
        if (next) next.disabled = (!this.cards.length || index === this.cards.length - 1) && (!this.nextUrl || this.loadingMore);
        if (position) position.textContent = this.cards.length ? String(index + 1) : '';
        if (empty) empty.hidden = Boolean(this.cards.length || this.nextUrl || this.loadingMore);
      }

      async moveCard(direction) {
        if (!this.cards.length && !this.nextUrl) return;
        const current = this.pendingNavigationCard || this.activeCard || this.cards[0];
        const index = Math.max(0, this.cards.indexOf(current));
        const targetIndex = Math.max(0, index + direction);
        if (targetIndex >= this.cards.length && this.nextUrl) await this.loadMore();
        const target = this.cards[targetIndex];
        if (!target) return;
        this.restartOnboarding();
        this.pendingNavigationCard = target;
        const top = this.feed.scrollTop + target.getBoundingClientRect().top - this.feed.getBoundingClientRect().top;
        this.feed.scrollTo({ top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }

      bindOnboarding() {
        const cue = this.querySelector('[data-swipe-onboarding]');
        if (!cue) return;
        this.boundCancelOnboarding = (event) => {
          if (event.type === 'pointerdown' || event.type === 'touchstart') this.onboardingInteracting = true;
          this.restartOnboarding();
        };
        this.boundResumeOnboarding = () => {
          this.onboardingInteracting = false;
          this.restartOnboarding();
        };
        this.boundOnboardingScroll = () => {
          if (!this.classList.contains('is-onboarding-active')) this.restartOnboarding();
        };
        this.boundOnboardingResize = () => {
          if (!window.matchMedia('(max-width: 749px)').matches || this.classList.contains('is-onboarding-motion')) this.restartOnboarding();
          else this.scheduleOnboarding();
        };
        this.boundOnboardingVisibility = () => {
          this.onboardingInteracting = false;
          this.restartOnboarding();
        };
        this.feed.addEventListener('pointerdown', this.boundCancelOnboarding, { passive: true });
        this.feed.addEventListener('touchstart', this.boundCancelOnboarding, { passive: true });
        this.feed.addEventListener('wheel', this.boundCancelOnboarding, { passive: true });
        this.feed.addEventListener('keydown', this.boundCancelOnboarding);
        this.feed.addEventListener('change', this.boundCancelOnboarding);
        this.feed.addEventListener('focusin', this.boundCancelOnboarding);
        this.feed.addEventListener('focusout', this.boundResumeOnboarding);
        this.feed.addEventListener('scroll', this.boundOnboardingScroll, { passive: true });
        window.addEventListener('pointerup', this.boundResumeOnboarding, { passive: true });
        window.addEventListener('pointercancel', this.boundResumeOnboarding, { passive: true });
        window.addEventListener('touchend', this.boundResumeOnboarding, { passive: true });
        window.addEventListener('touchcancel', this.boundResumeOnboarding, { passive: true });
        window.addEventListener('resize', this.boundOnboardingResize);
        document.addEventListener('visibilitychange', this.boundOnboardingVisibility);
        this.scheduleOnboarding();
      }

      onboardingCardAtRest() {
        const card = this.activeCard || this.cards[0];
        const index = this.cards.indexOf(card);
        if (!card || index < 0 || index >= this.cards.length - 1 || this.feed.clientHeight === 0) return null;
        if (Math.abs(card.getBoundingClientRect().top - this.feed.getBoundingClientRect().top) > 2) return null;
        return card;
      }

      scheduleOnboarding() {
        if (!this.isConnected || this.onboardingTimer != null || document.hidden || this.onboardingInteracting || !window.matchMedia('(max-width: 749px)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches || this.classList.contains('is-onboarding-motion') || document.activeElement?.matches('select, input, textarea, shopify-chat') || !this.onboardingCardAtRest()) return;
        if (!this.onboardingDueAt) this.onboardingDueAt = performance.now() + (this.onboardingPlayed ? 7000 : 3000);
        this.onboardingTimer = window.setTimeout(() => this.startOnboarding(), Math.max(0, this.onboardingDueAt - performance.now()));
      }

      restartOnboarding() {
        this.cancelOnboarding();
        this.onboardingPlayed = true;
        this.onboardingDueAt = performance.now() + 7000;
        this.scheduleOnboarding();
      }

      cancelOnboarding() {
        clearTimeout(this.onboardingTimer);
        this.onboardingTimer = null;
        this.onboardingToken += 1;
        this.onboardingCueCard?.classList.remove('is-onboarding-cue');
        this.onboardingCueCard = null;
        this.classList.remove('is-onboarding-active', 'is-onboarding-motion');
      }

      async startOnboarding() {
        this.onboardingTimer = null;
        const card = this.onboardingCardAtRest();
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        if (!this.isConnected || !isMobile || document.hidden || this.onboardingInteracting || !card || window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.activeElement?.matches('select, input, textarea, shopify-chat')) {
          this.cancelOnboarding();
          return;
        }

        this.onboardingPlayed = true;
        this.onboardingDueAt = performance.now() + 7000;
        const token = ++this.onboardingToken;
        this.onboardingCueCard = card;
        card.classList.add('is-onboarding-cue');
        this.classList.add('is-onboarding-active');

        const start = this.feed.scrollTop;
        const distance = Math.round(card.getBoundingClientRect().height * 0.25);
        const target = Math.min(start + distance, this.feed.scrollHeight - this.feed.clientHeight);
        this.classList.add('is-onboarding-motion');

        if (!await this.onboardingDelay(140, token)) return;
        if (!await this.animateOnboardingScroll(start, target, 720, token)) return;
        if (!await this.onboardingDelay(800, token)) return;
        if (!await this.animateOnboardingScroll(target, start, 820, token)) return;

        this.feed.scrollTop = start;
        this.classList.remove('is-onboarding-motion');
        if (!await this.onboardingDelay(260, token)) return;
        if (token === this.onboardingToken) {
          this.onboardingCueCard?.classList.remove('is-onboarding-cue');
          this.onboardingCueCard = null;
          this.classList.remove('is-onboarding-active');
          this.scheduleOnboarding();
        }
      }

      onboardingDelay(duration, token) {
        return new Promise((resolve) => {
          window.setTimeout(() => resolve(token === this.onboardingToken), duration);
        });
      }

      animateOnboardingScroll(from, to, duration, token) {
        return new Promise((resolve) => {
          const startedAt = performance.now();
          const step = (now) => {
            if (token !== this.onboardingToken) {
              resolve(false);
              return;
            }
            const progress = Math.min(1, (now - startedAt) / duration);
            const eased = progress < 0.5
              ? 4 * progress * progress * progress
              : 1 - Math.pow(-2 * progress + 2, 3) / 2;
            this.feed.scrollTop = from + ((to - from) * eased);
            if (progress < 1) window.requestAnimationFrame(step);
            else resolve(true);
          };
          window.requestAnimationFrame(step);
        });
      }

      removeDuplicates() {
        const handles = new Set();
        this.querySelectorAll('[data-swipe-card]').forEach((card) => {
          const handle = card.dataset.productHandle;
          if (handles.has(handle)) card.remove();
          else handles.add(handle);
        });
      }

      refreshConsent() {
        try {
          this.canPersist = Boolean(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.());
        } catch (error) {
          this.canPersist = false;
        }
        if (!this.canPersist) return;
        try {
          const saved = JSON.parse(localStorage.getItem(this.profileKey));
          if (saved?.categories) this.profile = saved;
        } catch (error) {
          this.profile = { categories: {} };
        }
      }

      saveProfile() {
        if (!this.canPersist) return;
        try { localStorage.setItem(this.profileKey, JSON.stringify(this.profile)); }
        catch (error) { this.canPersist = false; }
      }

      learn(category, amount) {
        const current = Number(this.profile.categories[category] || 0);
        this.profile.categories[category] = Math.max(-12, Math.min(24, current + amount));
        this.saveProfile();
      }

      publish(name, card, extra = {}) {
        const payload = { productId: card?.dataset.productId || '', productHandle: card?.dataset.productHandle || '', category: card?.dataset.category || '', position: Number(card?.dataset.position || 0), ...extra };
        try { window.Shopify?.analytics?.publish(`nks:${name}`, payload); }
        catch (error) { return; }
      }

      observeCards(cards) {
        if (!this.observer) {
          this.observer = new IntersectionObserver((entries) => {
            const active = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
            if (active && active.intersectionRatio >= 0.72) this.activate(active.target);
          }, { root: this.feed, threshold: [0.72, 0.9] });
        }
        cards.forEach((card) => this.observer.observe(card));
      }

      activate(card) {
        if (card === this.activeCard) return;
        const previousCard = this.activeCard;
        const now = Date.now();
        if (this.activeCard) {
          const dwellMs = now - this.activeSince;
          const category = this.activeCard.dataset.category;
          if (dwellMs < 1500) this.learn(category, -2);
          else if (dwellMs >= 7000) this.learn(category, 2);
          else if (dwellMs >= 4000) this.learn(category, 1);
          this.publish('swipe_completed', this.activeCard, { dwellMs });
        }
        clearTimeout(this.viewTimer);
        this.activeCard = card;
        if (this.pendingNavigationCard === card) this.pendingNavigationCard = null;
        this.activeSince = now;
        this.updateNavigation();
        if (previousCard) this.restartOnboarding();
        else this.scheduleOnboarding();
        const activeIndex = this.cards.indexOf(card);
        if (activeIndex >= this.cards.length - 4) this.loadMore();
        this.viewTimer = setTimeout(() => {
          if (this.activeCard !== card) return;
          this.publish('swipe_viewed', card, { dwellMs: Date.now() - this.activeSince });
        }, 1200);
      }

      async loadMore() {
        if (this.loadingPromise) return this.loadingPromise;
        if (!this.nextUrl || !this.sectionId) return;
        this.loadingMore = true;
        this.updateNavigation();
        this.loadedPageUrls ||= new Set();
        const loading = (async () => {
          try {
            while (this.nextUrl) {
              const url = new URL(this.nextUrl, window.location.origin);
              if (url.origin !== window.location.origin) throw new Error('pagination');
              url.searchParams.set('view', 'swipe');
              url.searchParams.set('section_id', this.sectionId);
              if (this.loadedPageUrls.has(url.toString())) {
                this.nextUrl = '';
                break;
              }
              const response = await fetch(url.toString(), {
                credentials: 'same-origin',
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
              });
              if (!response.ok) throw new Error('pagination');
              const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
              const nextShop = documentFragment.querySelector('nks-swipe-shop');
              if (!nextShop) throw new Error('pagination');
              this.loadedPageUrls.add(url.toString());

              const existingHandles = new Set(this.cards.map((card) => card.dataset.productHandle));
              const newCards = [...nextShop.querySelectorAll('[data-swipe-card]')].filter((card) => {
                const handle = card.dataset.productHandle;
                if (!handle || existingHandles.has(handle)) return false;
                existingHandles.add(handle);
                return true;
              });

              this.nextUrl = nextShop.dataset.nextUrl || '';
              if (!newCards.length) continue;

              const fragment = document.createDocumentFragment();
              newCards.forEach((card) => fragment.append(card));
              this.feed.append(fragment);
              this.cards.push(...newCards);
              this.bindVariants(newCards);
              this.bindActions(newCards);
              this.observeCards(newCards);
              this.scheduleOnboarding();
              break;
            }
          } catch (error) {
            return;
          } finally {
            this.loadingMore = false;
            this.updateNavigation();
          }
        })();
        this.loadingPromise = loading;
        try {
          return await loading;
        } finally {
          if (this.loadingPromise === loading) this.loadingPromise = null;
        }
      }

      bindVariants(cards) {
        cards.forEach((card) => card.querySelectorAll('[data-swipe-variant]').forEach((select) => {
          select.addEventListener('change', () => {
            const card = select.closest('[data-swipe-card]');
            const input = card.querySelector('[data-swipe-variant-input]');
            const quantity = card.querySelector('[name="quantity"]');
            const price = card.querySelector('[data-swipe-price]');
            if (input) input.value = select.value;
            if (quantity) quantity.value = select.selectedOptions[0]?.dataset.quantityMin || '1';
            card.querySelectorAll('[data-nks-icon-action]').forEach((button) => {
              button.disabled = !!select.selectedOptions[0]?.disabled;
            });
            if (price) price.textContent = select.selectedOptions[0]?.dataset.price || price.textContent;
            this.publish('variant_selected', card, { variantId: select.value });
          });
        }));
      }

      bindActions(cards) {
        cards.forEach((card) => card.querySelectorAll('nks-icon-purchase').forEach((purchase) => {
          if (purchase.dataset.swipeTrackingBound) return;
          purchase.dataset.swipeTrackingBound = 'true';
          purchase.addEventListener('nks:cart-added', (event) => {
            const advance = event.detail.advance;
            this.learn(card.dataset.category, advance ? 8 : 6);
            this.publish(advance ? 'swipe_continue_order' : 'swipe_add_to_cart', card, { variantId: event.detail.variantId });
            this.refreshCartCount();
            this.showToast(this.dataset.addedLabel);
          });
        }));
      }

      async refreshCartCount() {
        if (window.nksFastCart?.syncCount) return window.nksFastCart.syncCount();
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          const cart = await response.json();
          if (window.nksFastCart?.syncCount) return window.nksFastCart.syncCount();
          document.querySelectorAll('.nks-mobile-dock__count').forEach((count) => {
            count.textContent = cart.item_count;
            count.classList.toggle('is-empty', cart.item_count === 0);
          });
        } catch (error) { return; }
      }

      showToast(message) {
        const toast = this.querySelector('[data-swipe-toast]');
        if (!toast) return;
        clearTimeout(this.toastTimer);
        toast.textContent = message;
        toast.classList.add('is-visible');
        this.toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 1500);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nks-tent-configurator"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-nks-tent-configurator]').forEach((configurator) => {
    if (configurator.dataset.initialized === 'true') return;
    configurator.dataset.initialized = 'true';

    const variantsElement = configurator.querySelector('[data-tent-variants]');
    const variants = JSON.parse(variantsElement.textContent);
    const radios = [...configurator.querySelectorAll('[data-option-position] input[type="radio"]')];
    const preview = configurator.querySelector('[data-tent-preview]');
    const estimateOutput = configurator.querySelector('[data-tent-estimate]');
    const estimateInput = configurator.querySelector('[data-tent-estimate-input]');
    const configurationInput = configurator.querySelector('[data-tent-configuration]');
    const variantInput = configurator.querySelector('[data-tent-variant-id]');
    const bodyInput = configurator.querySelector('[data-tent-body]');
    const countOutput = configurator.querySelector('[data-configuration-count]');
    const selectedOutputs = [...configurator.querySelectorAll('[data-selected-option]')];
    const cards = [...configurator.querySelectorAll('[data-variant-card]')];
    const locale = configurator.dataset.locale || 'en-US';
    const currency = configurator.dataset.currency || 'USD';
    const buffer = Number(configurator.dataset.buffer || 0);
    const money = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      maximumFractionDigits: 0,
    });

    const priceTable = {
      sizes: [
        Number(configurator.getAttribute('data-base-10x10') || 0),
        Number(configurator.getAttribute('data-base-10x15') || 0),
        Number(configurator.getAttribute('data-base-10x20') || 0),
      ],
      backWalls: [
        Number(configurator.getAttribute('data-back-10x10') || 0),
        Number(configurator.getAttribute('data-back-10x15') || 0),
        Number(configurator.getAttribute('data-back-10x20') || 0),
      ],
      sideWalls: Number(configurator.dataset.sideWalls || 0),
      twoFlags: Number(configurator.dataset.twoFlags || 0),
      tableCover: Number(configurator.dataset.tableCover || 0),
    };

    const getSelectedRadios = () => [1, 2, 3].map((position) => {
      const selected = configurator.querySelector(`[data-option-position="${position}"] input:checked`);
      return selected || null;
    });

    const getEstimate = ([sizeIndex, wallsIndex, extrasIndex]) => {
      let low = priceTable.sizes[sizeIndex] || 0;
      const backWall = priceTable.backWalls[sizeIndex] || 0;

      if (wallsIndex === 0) low += backWall;
      if (wallsIndex === 1) low += priceTable.sideWalls;
      if (wallsIndex === 2) low += backWall + priceTable.sideWalls;
      if (extrasIndex === 0) low += priceTable.twoFlags;
      if (extrasIndex === 1) low += priceTable.tableCover;
      if (extrasIndex === 3) low += priceTable.twoFlags + priceTable.tableCover;

      return {
        low,
        high: Math.ceil((low * (1 + buffer / 100)) / 5000) * 5000,
      };
    };

    const setPreview = (variant) => {
      const swapImage = () => {
        if (!preview || !variant.image) return;
        preview.removeAttribute('srcset');
        preview.removeAttribute('sizes');
        preview.src = variant.image;
        preview.alt = variant.alt || variant.title;
      };

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (document.startViewTransition && !reduceMotion) {
        document.startViewTransition(swapImage);
      } else {
        swapImage();
      }
    };

    const update = ({ updateImage = true, updateUrl = true } = {}) => {
      const selectedRadios = getSelectedRadios();
      if (selectedRadios.some((radio) => !radio)) return;
      const selections = selectedRadios.map((radio) => radio.value);
      const selectionIndexes = selectedRadios.map((radio) => Number(radio.dataset.valueIndex));
      const variant = variants.find((item) => item.options.every((option, index) => option === selections[index]));
      if (!variant) return;

      const estimate = getEstimate(selectionIndexes);
      const estimateText = `${money.format(estimate.low / 100)}–${money.format(estimate.high / 100)}`;
      const configurationText = selections.join(' / ');
      const variantIndex = variants.findIndex((item) => item.id === variant.id);

      if (updateImage) setPreview(variant);
      estimateOutput.textContent = estimateText;
      estimateInput.value = estimateText;
      configurationInput.value = configurationText;
      variantInput.value = variant.id;
      bodyInput.value = `${configurator.dataset.configurationPrefix} ${configurationText}. ${configurator.dataset.estimatePrefix} ${estimateText}.`;
      selectedOutputs.forEach((output, index) => {
        const selected = configurator.querySelector(`[data-option-position="${index + 1}"] input:checked`);
        const localizedLabel = selected?.nextElementSibling?.querySelector('strong')?.textContent.trim();
        output.textContent = localizedLabel || selections[index];
      });
      countOutput.textContent = configurator.dataset.countTemplate.replace('__CURRENT__', String(variantIndex + 1));

      cards.forEach((card) => {
        const selected = card.dataset.variantCard === String(variant.id);
        card.classList.toggle('is-selected', selected);
        if (selected) card.setAttribute('aria-current', 'true');
        else card.removeAttribute('aria-current');
      });

      if (updateUrl && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    };

    radios.forEach((radio) => radio.addEventListener('change', () => update()));

    cards.forEach((card) => {
      card.addEventListener('click', () => {
        const variant = variants.find((item) => String(item.id) === card.dataset.variantCard);
        if (!variant) return;

        variant.options.forEach((value, index) => {
          const radio = radios.find((item) => item.value === value && item.closest('[data-option-position]').dataset.optionPosition === String(index + 1));
          if (radio) radio.checked = true;
        });

        update();
        configurator.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
    });

    update({ updateImage: false, updateUrl: false });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nks-tent-quote"] && !Shopify.designMode) return;
  try {
    
const NKSTentQuoteEngine=(()=>{
  const quantity=(value,min=0)=>{const n=Number(value);if(!Number.isInteger(n)||n<min||n>99)throw new Error('invalid_quantity');return n;};
  const resolve=(data,options)=>data.product.variants.find(v=>v.options.every((o,i)=>o===options[i])) || null;
  const compatible=(record,size)=>record.sizes.includes(size);
  const evaluate=(data,state)=>{
    const count=quantity(state.quantity,1);const variant=resolve(data,state.options);
    if(!variant)throw new Error('invalid_configuration');
    const kit=data.kits.find(k=>k.options.every((o,i)=>o===state.options[i])) || null;
    const includes=kit?kit.includes:{
      back_wall:/Back/.test(state.options[1])?1:0,
      side_wall:/Side/.test(state.options[1])?2:0,
      flag:/2 Flags/.test(state.options[2])?2:0,
      table_cover:/Table Cover/.test(state.options[2])?1:0
    };
    const components=[];const rejected=[];
    for(const entry of state.components || []){
      const desired=quantity(entry.quantity);if(!desired)continue;
      const record=data.components.find(c=>c.key===entry.key);
      const selected=record?.product.variants.find(v=>String(v.id)===String(entry.variantId));
      if(!record || !compatible(record,state.options[0]) || !selected){rejected.push(entry);continue;}
      components.push({key:record.key,role:record.role,productId:record.product.id,productTitle:record.product.title,variant:selected,totalPerKit:desired,totalRequested:desired*count,compatibilityConfirmed:false});
    }
    return {variant,kit,includes,components,rejected,quantity:count,quoteOnly:true,orderCreated:false};
  };
  const quote=(data,state,group)=>{
    if(!group || group.length>80)throw new Error('invalid_group');
    const r=evaluate(data,state);
    return JSON.stringify({
      request_group:group,snapshot_verified_at:data.verifiedAt,
      source_product_id:data.product.id,reference_configuration_id:r.variant.id,
      reference_configuration_photo:r.variant.image,options:state.options,setup_quantity:r.quantity,
      candidate_kit_product_id:r.kit?.product.id || null,
      candidate_kit_variant_id:r.kit?.product.variants[0]?.id || null,
      selected_package_contents:r.includes,package_contents_confirmed:false,
      components:r.components.map(c=>({role:c.role,product_id:c.productId,product_title:c.productTitle,variant_id:c.variant.id,sku:c.variant.sku,title:c.variant.title,total_per_setup:c.totalPerKit,total_requested:c.totalRequested,compatibility_confirmed:false})),
      rejected_components:r.rejected,requires_complete_quote:true,order_created:false,invoice_created:false,account_balance_created:false
    },null,2);
  };
  const restore=(data,params,defaultId)=>{
    const id=params.get('configuration') || defaultId;
    const variant=data.product.variants.find(v=>String(v.id)===String(id));
    if(!variant)throw new Error('invalid_configuration');
    const readCount=(value,min)=>{
      if(!/^\d{1,2}$/.test(value))throw new Error('invalid_quantity');
      return quantity(value,min);
    };
    const count=params.has('kit_qty')?readCount(params.get('kit_qty'),1):1;
    const raw=params.get('components') || '';
    const seen=new Set();const components=[];
    if(raw)for(const tuple of raw.split(',')){
      const parts=tuple.split(':');
      if(parts.length!==3 || seen.has(parts[0]))throw new Error('invalid_components');
      const [key,variantId,value]=parts;
      const record=data.components.find(c=>c.key===key);
      if(!record || !compatible(record,variant.options[0]) || !record.product.variants.some(v=>String(v.id)===variantId))throw new Error('invalid_components');
      seen.add(key);const desired=readCount(value,0);
      if(desired)components.push({key,variantId,quantity:desired});
    }
    return {options:variant.options.slice(),quantity:count,components};
  };
  const persist=(data,state,href)=>{
    const r=evaluate(data,state);
    if(r.rejected.length)throw new Error('invalid_components');
    const url=new URL(href);url.searchParams.set('configuration',r.variant.id);url.searchParams.delete('variant');
    if(r.quantity===1)url.searchParams.delete('kit_qty');else url.searchParams.set('kit_qty',String(r.quantity));
    const tuples=r.components.slice().sort((a,b)=>a.key.localeCompare(b.key)).map(c=>c.key+':'+c.variant.id+':'+c.totalPerKit);
    if(tuples.length)url.searchParams.set('components',tuples.join(','));else url.searchParams.delete('components');
    return url;
  };
  return {quantity,resolve,compatible,evaluate,quote,restore,persist};
})();
if(typeof module!=='undefined' && module.exports)module.exports=NKSTentQuoteEngine;
if(typeof window!=='undefined'){
  window.NKSTentQuoteEngine=NKSTentQuoteEngine;
  if(!customElements.get('nks-tent-quote'))customElements.define('nks-tent-quote',class extends HTMLElement{
    connectedCallback(){
      if(this.initialized)return;this.initialized=true;
      this.data=JSON.parse(this.querySelector('[data-tent-data]').textContent);
      this.group='tent-quote-'+(crypto.randomUUID?crypto.randomUUID():String(Date.now())+'-'+Math.random().toString(36).slice(2));
      try{
        const saved=NKSTentQuoteEngine.restore(this.data,new URL(location.href).searchParams,this.dataset.initialVariant);
        saved.options.forEach((value,i)=>{const input=[...this.querySelectorAll('[data-option-position="'+(i+1)+'"] input')].find(r=>r.value===value);if(input)input.checked=true;});
        this.querySelector('[data-kit-quantity]').value=String(saved.quantity);
        saved.components.forEach(c=>{
          const el=[...this.querySelectorAll('[data-component]')].find(e=>e.dataset.component===c.key);
          if(!el)throw new Error('invalid_components');
          el.querySelector('[data-component-variant]').value=c.variantId;
          el.querySelector('[data-component-quantity]').value=String(c.quantity);
        });
      }catch(e){this.restoreError=true;}
      this.addEventListener('change',e=>{if(e.target.matches('input[type="radio"],input[type="number"],[data-component-variant]')){this.restoreError=false;this.update();}});
      this.addEventListener('input',e=>{if(e.target.matches('input[type="number"]')){this.restoreError=false;this.update();}});
      this.querySelector('form').addEventListener('submit',e=>{if(!this.querySelector('[data-quote-payload]').value)e.preventDefault();});
      this.update(false);
    }
    state(){return {
      options:[1,2,3].map(i=>this.querySelector('[data-option-position="'+i+'"] input:checked')?.value),
      quantity:Number(this.querySelector('[data-kit-quantity]').value),
      components:[...this.querySelectorAll('[data-component]')].map(el=>({key:el.dataset.component,variantId:el.querySelector('[data-component-variant]').value,quantity:Number(el.querySelector('[data-component-quantity]').value)}))
    };}
    list(element,entries){element.replaceChildren(...entries.map(text=>{const li=document.createElement('li');li.textContent=text;return li;}));}
    update(updateUrl=true){
      try{
        if(this.restoreError)throw new Error('invalid_configuration');
        const state=this.state();
        for(const el of this.querySelectorAll('[data-component]')){
          const record=this.data.components.find(c=>c.key===el.dataset.component);
          const fits=record && NKSTentQuoteEngine.compatible(record,state.options[0]);
          el.hidden=!fits;
          if(!fits)el.querySelector('[data-component-quantity]').value='0';
          el.querySelector('[data-component-status]').textContent=this.data.labels.compatibility;
        }
        const r=NKSTentQuoteEngine.evaluate(this.data,this.state());this.result=r;
        const image=this.querySelector('.nks-tent-order__preview');
        if(image && image.getAttribute('src')!==r.variant.image){image.src=r.variant.image;image.alt=r.variant.title;}
        this.querySelector('[data-selection-summary]').textContent=r.variant.title;
        this.list(this.querySelector('[data-includes]'),Object.entries(r.includes).filter(e=>e[1]>0).map(e=>(this.data.labels[e[0]] || e[0])+' × '+e[1]));
        this.querySelector('[data-total]').textContent=this.data.labels.quote;
        this.querySelector('[data-order-status]').textContent=this.data.labels.pending;
        this.list(this.querySelector('[data-lines]'),r.components.map(c=>(this.data.labels[c.role] || c.role)+' · '+c.productTitle+' · '+c.variant.title+' × '+c.totalRequested));
        this.querySelector('[data-quote-payload]').value=NKSTentQuoteEngine.quote(this.data,this.state(),this.group);
        this.querySelector('[data-quote-configuration]').value=this.state().options.join(' / ')+'\n'+this.data.labels.quantity+': '+r.quantity+'\n'+r.components.map(c=>(this.data.labels[c.role] || c.role)+' · '+c.productTitle+' · '+c.variant.title+' × '+c.totalRequested).join('\n')+'\n'+this.data.labels.pending;
        this.querySelector('[data-quote-panel] button[type="submit"]').disabled=false;
        if(updateUrl)history.replaceState({},'',NKSTentQuoteEngine.persist(this.data,this.state(),location.href));
      }catch(e){
        this.querySelector('[data-quote-payload]').value='';
        this.querySelector('[data-quote-configuration]').value='';
        this.querySelector('[data-quote-panel] button[type="submit"]').disabled=true;
        this.querySelector('[data-order-status]').textContent=this.data.labels.invalid;
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
